import React from 'react';

import Header from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';
import banner from '../../Assets/Research-Fund-Banner.jpg';
import introductionImage from '../../Assets/Research-Fund-Introduction.png';
import '../../Styles/Linkages&Outreach.css';
import '../../Styles/ResearchFund.css';
import ResearchFundProcess from './ResearchFundProcess';
import ResearchFundProjects from './ResearchFundProjects';
import FooterQuote from '../../Layout/FooterQuote';

const ResearchFundPage = () => (
  <>
    <Header />
    <main className="research-fund-page">
      <section className="outreach-event-hero" aria-label="NCGSA Research Fund Program">
        <img src={banner} alt="NCGSA Research Fund Program" />
      </section>
      <section className="research-fund-introduction" aria-labelledby="research-fund-introduction-title">
        <div className="research-fund-introduction-inner">
          <div className="research-fund-introduction-copy">
            <p className="section-eyebrow">ADVANCING RESEARCH · ENABLING INNOVATION</p>
            <h1 id="research-fund-introduction-title">Introduction</h1>
            <div className="research-fund-title-line" aria-hidden="true" />
            <p>
              In a significant move to advance scientific research and innovation in Pakistan, the
              National Centre of GIS and Space Applications (NCGSA) launched its flagship Research
              Fund (RF) program on March 22, 2021, according to the approved PC-1. With a substantial
              allocation of PKR 200 million, this initiative was designed to support and promote
              cutting-edge research in the domains of Geographic Information Science (GISc.) and
              Space Applications.
            </p>
            <p>
              The primary aim of the Research Fund program is to catalyze the development of
              innovative, market-oriented, and application-driven research that leverages modern
              geospatial technologies and space-based tools. Faculty members and researchers of
              Higher Education Institutions and Research & Development Organizations of Pakistan
              were invited to submit proposals focused on the sustainable socio-economic development
              of Pakistan through Space Science, Technology, and its Applications. Proposals were
              joint industry-academia projects of a maximum duration of 24 months and a maximum
              budget of PKR 15 million. The NCGSA Research Fund Program holds strategic importance
              for Pakistan’s academic, industrial, and national development landscape.
            </p>
          </div>
          <figure className="research-fund-introduction-image">
            <img src={introductionImage} alt="NCGSA Research Fund projects" />
          </figure>
        </div>
      </section>
      <ResearchFundProcess />
      <ResearchFundProjects />
    </main>
    <FooterQuote
      variant="fund"
      quote="If you are able to pass beyond the regions of the heavens and the earth, then pass. You will not pass except by authority."
      attribution="Qur’an 55:33"
    />
    <FooterComponent />
  </>
);

export default ResearchFundPage;
